var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60734 0.802606C7.2259 -0.214965 8.70286 -0.214963 9.32142 0.802608L15.5718 11.0849C16.2151 12.1432 15.4533 13.4979 14.2148 13.4979H1.71399C0.475474 13.4979 -0.286384 12.1432 0.356949 11.0849L6.60734 0.802606Z",
    fill: "#F04438"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88471 10.8172C8.88471 11.3255 8.47264 11.7376 7.96433 11.7376C7.45601 11.7376 7.04395 11.3255 7.04395 10.8172C7.04395 10.3089 7.45601 9.89685 7.96433 9.89685C8.47264 9.89685 8.88471 10.3089 8.88471 10.8172Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96436 8.84705C7.59788 8.84705 7.30078 8.64153 7.30078 8.38801L7.30078 3.42608C7.30078 3.17257 7.59788 2.96705 7.96436 2.96705C8.33085 2.96705 8.62795 3.17257 8.62795 3.42608V8.38801C8.62795 8.64153 8.33085 8.84705 7.96436 8.84705Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.c6ee2fb8af0dc0eddfd616cdb6d1e3db.svg";
export { ForwardRef as ReactComponent };